import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class Start extends Component {
  render(){
    const { classes, theme, location } = this.props;
    return(
      <div className={classes.root}>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          To create a saved search we offer 6 different filters. These allow you to reduce the 5000 candidates in your library to the 100 or so more relevant for you.
        </Typography>
        <Button onClick={() => {this.props.changeRoute("/console/search/create_new_search/six_basic_filters");}} className={classes.button} raised color="primary">
          Apply Six Basic Filters
        </Button>
        <Button disabled onClick={() => {this.props.changeRoute("/console/search/create_new_search/premium_displays");}} className={classes.button} raised color="primary">
          Add Premium Highlights
        </Button>
        <Button disabled onClick={() => {this.props.changeRoute("/console/search/create_new_search/concierge_filters");}} className={classes.button} raised color="primary">
          Add Concierge Filters
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Start)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/Start/index.js